import iconsSet from 'icons/selection.json';
import { includes } from 'lodash';


export const getIconBackgroundImage = (iconName: string, iconColor: string, width: number | string = '100%', height: number | string = '100%', iconPaths = iconsSet): string => {
  const icon = iconPaths.icons.find(_icon => includes(_icon.tags, iconName));
  if (icon) {
    return `background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='${encodeURIComponent(height)}' width='${encodeURIComponent(width)}' viewBox='0 0 1024 1024' aria-label='toqio-icon-svg'%3E%3Cpath fill='${encodeURIComponent(iconColor)}' color='%2315B2EB' d='${icon.paths.join(' ')}' class='r-6ywwu7' style='%0A'%3E%3C/path%3E%3C/svg%3E");`
  } else {
    console.warn(`icon ${iconName} does not exist.`);
    return '';
  }
}


export const getRGBA = (hex: string | null | undefined, a: number): string => {
  if (!hex) return ''
  else {
    const rgb = hex?.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_m, r, g, b) => `#${r}${r}${g}${g}${b}${b}`)
      ?.substring(1)
      ?.match(/.{2}/g)
      ?.map(x => parseInt(x, 16))
    return `rgba(${rgb?.[0]},${rgb?.[1]},${rgb?.[2]},${a})`;
  }
}